import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { HelmetProvider } from 'react-helmet-async';
import { useEffect } from 'react';
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import theme from "./theme";

import { AuthProvider } from "./context/AuthContext";
import { CookieProvider } from "./context/CookieContext";


import PrivateRoute from "./utils/PrivateRoute";
import Header from "./components/Header";
import ScrollToTop from "./components/ScrollToTop";
import PageViewTracker from "./components/PageViewTracker";
import { initGA } from "./utils/analytics";
import RegistrationPage from "./pages/RegistrationPage";
import CalendarPage from "./pages/CalendarPage";
import StatisticsPage from "./pages/StatisticsPage";
import ProfilePage from "./pages/ProfilePage";
import TodayPage from "./pages/TodayPage";
import LoginPage from "./pages/LoginPage";
import Page404 from "./pages/404Page";
import LandingPage from "./pages/LandingPage";
import RootRoute from "./utils/RootRoute";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import RelationshipPage from "./pages/RelationshipPage";
import ChoresTimeoffPage from "./pages/ChoresTimeoffPage";
import ForgotPasswordPage from "./pages/ForgotPasswordPage";
import VerifyEmail from "./components/VerifyEmail";
import ResetPasswordPage from "./pages/ResetPasswordPage";
import VerifiedRoute from "./utils/VerifiedRoute";
import FeedbackPage from "./pages/FeedbackPage";
import AccountDeletedPage from "./pages/AccountDeletedPage";
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage";
import DeleteAccountPage from "./pages/DeleteAccountPage";
import ChildSafetyStandardsPage from "./pages/ChildSafetyStandardsPage";
import TermsOfServicePage from "./pages/TermsOfServicePage";
import CookieConsent from "./components/CookieConsent";
import CookieSettings from "./components/CookieSettings";

function App() {
  useEffect(() => {
    initGA();
  }, []);

  return (
    <ThemeProvider theme={theme}>
    <CssBaseline />
    <HelmetProvider>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <CookieProvider>
          <div className="App">
            <Router>
              <ScrollToTop />
              <PageViewTracker />
              <AuthProvider>
                <Header />
                <Routes>
                  {/* Public routes */}
                  <Route path="/" element={<RootRoute />} />
                  <Route path="/login" element={<LoginPage />} />
                  <Route path="/register" element={<RegistrationPage />} />
                  <Route path="/verify-email" element={<VerifyEmail />} />
                  <Route path="/forgot-password" element={<ForgotPasswordPage />} />
                  <Route path="/reset-password" element={<ResetPasswordPage />} />
                  <Route path="/account-deleted" element={<AccountDeletedPage />} />
                  <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
                  <Route path="/delete-account" element={<DeleteAccountPage />} />
                  <Route path="/child-safety-standards" element={<ChildSafetyStandardsPage />} />
                  <Route path="/terms-of-service" element={<TermsOfServicePage />} />

                  {/* Protected routes that require verification */}
                  <Route element={<PrivateRoute />}>
                    <Route element={<VerifiedRoute />}>
                      <Route path="/today" element={<TodayPage />} />
                      <Route path="/statistics" element={<StatisticsPage />} />
                      <Route path="/calendar" element={<CalendarPage />} />
                      <Route path="/profile" element={<ProfilePage />} />
                      <Route path="/relationship" element={<RelationshipPage />} />
                      <Route path="/chores-timeoff" element={<ChoresTimeoffPage />} />
                      <Route path="/feedback" element={<FeedbackPage />} />
                    </Route>
                  </Route>

                  {/* Catch-all route */}
                  <Route path="*" element={<Page404 />} />
                </Routes>
                <CookieConsent />
                <CookieSettings />
              </AuthProvider>
            </Router>
          </div>
        </CookieProvider>
      </LocalizationProvider>
    </HelmetProvider>
    </ThemeProvider>
  );
}

export default App;
